import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";

import { Community, CommunityService } from "../../../shared";
import { AngularEditorConfig } from "@kolkov/angular-editor";

@Component({
  selector: "community-editor-page",
  templateUrl: "./community-editor.component.html",
  styleUrls: [
    "./community-editor.component.scss",
    "../../../../assets/icon/icofont/css/icofont.scss",
    "../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CommunityEditorComponent implements OnInit {
  public community: Community = new Community();
  public communityForm: FormGroup;
  public tagField = new FormControl();
  public errors: Object = {};
  public isSubmitting: boolean = false;

  // editor config
  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "25rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    uploadUrl: "v1/images", // if needed
    customClasses: [
      // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  constructor(
    private communityService: CommunityService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.prepareCommunityForm();
    this.fetchCommunity();
    this.trackCommunityFormChanges();
  }

  public prepareCommunityForm() {
    this.communityForm = this.fb.group({
      image: "",
      name: ["", Validators.required],
      summary: ["", Validators.required],
      description: ["", Validators.required],
      tagList: new FormControl([]),
    });
  }

  public trackCommunityFormChanges() {
    this.communityForm.valueChanges.subscribe((value) => {
      this.updateCommunity(value);
    });
  }

  public fetchCommunity() {
    this.route.data.subscribe((data: { community: Community }) => {
      if (data.community) {
        this.community = data.community;
        this.communityForm.patchValue(data.community);
      }
    });
  }

  public updateCommunity(values: Object) {
    (<any>Object).assign(this.community, values);
  }

  public saveImage(url: string) {
    this.communityForm.patchValue({ image: url });
  }

  public saveCommunity() {
    this.errors = {};
    this.isSubmitting = true;

    this.communityService.saveOne(this.community).subscribe(
      (community: Community) => {
        this.fireSuccessAlert();
        this.router.navigateByUrl("/community/" + community.name);
      },
      (err) => {
        this.errors = err;
        this.isSubmitting = false;
        this.fireErrorAlert();
      }
    );
  }

  public openCommunityPublishConfirmation() {
    Swal.fire({
      title: "Sure you want to publish this uMuzi?",
      text: "You can edit the uMuzi after posting",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, publish!",
    }).then((result) => {
      if (result.value) {
        this.saveCommunity();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire("Published", "Your uMuzi has been created.", "success");
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your submission.", "warning");

    window.scrollTo(0, 0);

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }
}
